const reviewStatuses = {
  0: 'Pendente',
  1: 'Aceito',
  2: 'Recusado',
}

export default reviewStatuses
